var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lot.auction.type === 'timed')?_c('lot-view-bidding-timed'):(_vm.lot.auction.type === 'live')?_c('lot-view-bidding-live'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }